const ConsentType = {
  EXPLICIT: 'explicit',
  IMPLICIT: 'implicit',
} as const;

export default ConsentType;
